import { render } from "./PersonaDetalle.vue?vue&type=template&id=6d44a788"
import script from "./PersonaDetalle.vue?vue&type=script&lang=js"
export * from "./PersonaDetalle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__